import { match as teleopmachine } from "../../../src/params/teleopmachine.ts";

export const matchers = { teleopmachine };